import { doc } from "firebase/firestore";
import React from "react";
import { useParams } from "react-router-dom";
import { db } from "firebaseApp";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { Alert, CircularProgress, Container, Stack } from "@mui/material";
import View from "views/View";
import AIMenu from "ai-menu/AIMenu";

export default function AIMenuView() {
  const params = useParams();
  const menuId = params.menuId;

  const menuRef = doc(db, "aiMenus", menuId);
  const [aiMenu, loading, error] = useDocumentData(menuRef);

  const renderContent = () => {
    if (error) {
      console.log(error);
      return <Alert severity="error">Error loading menu</Alert>;
    }

    if (loading) {
      return <CircularProgress />;
    }

    return <AIMenu aiMenu={aiMenu} />;
  };

  return (
    <View>
      <Container maxWidth="md">
        <Stack alignItems="center" height="100%">{renderContent()}</Stack>
      </Container>
    </View>
  );
}
